import { PersonModel } from '@/types';

export const person: PersonModel = {
  name: 'Dominik',
  surname: 'Przystał',
  position: 'Head of Design',
  linkedinLink: 'https://pl.linkedin.com/in/dominik-przysta%C5%82'
};
